import FormDialog from "../common/FormDialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";

const OrderRecordsDialog = ({ open, onClose, rows = [] }) => {
  return (
    <FormDialog title="订单记录" open={open} onClose={onClose}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>订单编号</TableCell>
              <TableCell align="right">操作记录</TableCell>
              <TableCell align="right">操作时间</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {row.orderSN}
                </TableCell>
                <TableCell align="right">{row.detail}</TableCell>
                <TableCell align="right">{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </FormDialog>
  );
};

export default OrderRecordsDialog;
